import { useState, useEffect } from 'react'
import axios from 'axios'
import AspectRatio from '@mui/joy/AspectRatio'
import { v4 as uuidv4 } from 'uuid'

const ImageContainer = ({ url }) => (
    <AspectRatio ratio="1/1" objectFit="contain" sx={{ width: '100%' }}>
        <img src={url} />
    </AspectRatio>
)

const VideoContainer = ({ url }) => (
    <video
        class="embed-responsive-item"
        style={{ width: '100%', maxHeight: '60vh' }}
        muted
        loop
        controls
    >
        <source src={url} type="video/mp4" />
    </video>
)

export const MediaContainer = ({ url }) => {
    const [child, setChild] = useState(null)

    // NOTE: passing random string to invalidate cache due to CORS causing errors if the image is already
    // in user's browser cache.
    // See https://blog.keul.it/chrome-cors-issue-due-to-cache/ for more information into the issue.
    let testUrl = `${url}?cache_key=${uuidv4()}`
    useEffect(() => {
        axios
            .head(testUrl, {
                withCredentials: false,
            })
            .then((response) => {
                const type = response.headers['content-type']
                setChild(
                    type.startsWith('video') ? (
                        <VideoContainer url={url} />
                    ) : (
                        <ImageContainer url={url} />
                    )
                )
            })
    }, [])

    return <>{child}</>
}
